import { useState, useCallback } from 'react';

export const useDisclosure = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const open = useCallback(() => setIsOpen(true), []);

  const close = useCallback(() => setIsOpen(false), []);

  const toggle = useCallback((flag: undefined | boolean) => {
    if (typeof flag === 'undefined') {
      setIsOpen((state) => !state);
    } else {
      setIsOpen(Boolean(flag));
    }
  }, []);

  return { isOpen, open, close, toggle };
};
